module.exports = __webpack_public_path__ + "static/media/robust-management-icon.406612ae.svg";